import { render, staticRenderFns } from "./SingleProductDisplay.vue?vue&type=template&id=48dadbb8&scoped=true&"
import script from "./SingleProductDisplay.vue?vue&type=script&lang=js&"
export * from "./SingleProductDisplay.vue?vue&type=script&lang=js&"
import style0 from "./SingleProductDisplay.vue?vue&type=style&index=0&id=48dadbb8&lang=stylus&scoped=true&"
import style1 from "./SingleProductDisplay.vue?vue&type=style&index=1&id=48dadbb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48dadbb8",
  null
  
)

export default component.exports